/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import { Button, IconButton, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import { requestBoothPage, requestBoothExport } from "../../api/booth-list";
import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_ADVERTISMENT_ACTIVE, EXPORT_BOOTH, GET_ALL_BOOTH } from "../../../../shared/api/endpoints.js";
import { BoothChat as Chats } from "../../../messaging/index.js";
import BoothModal from "./modal.jsx";
var RENDER = 0;
const Booth = () => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openChat, setOpenChat] = useState(false);

  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  const { hasMore, loading, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_BOOTH,
      filter,
      true,
      refreshData,
      sumbitSearch, 1, false, undefined, requestBoothPage
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title="غرفه ها"
        broadCrumb={[
          {
            title: " غرفه و کاربران",
            path: "/booth",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
              <Exports
                requestExport={requestBoothExport}
                sumbitSearch={sumbitSearch}
                filter={filter}
                header={header}
                data={allData}
                selectedData={selected}
                title="غرفه ها"
                api={EXPORT_BOOTH}
              />

              <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن غرفه جدید
              </Button>
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_ADVERTISMENT_ACTIVE}
          title="غرفه ها"
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "چت",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenChat(true);
                    }}
                  >
                    <MarkUnreadChatAltOutlinedIcon sx={{ color: "#685aff" }} />
                  </IconButton>
                </>
              ),
            },
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <BoothModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      />
      <Modal
        open={openChat}
        close={() => {
          RENDER += 1;
          setOpenChat(false);
        }}
        title={`ارسال پیام
    `}
      >
        {" "}
        <Chats RENDER={RENDER} booth={editingData} />
      </Modal>
    </>
  );
};

export default Booth;
